import { useState } from "react";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useShop } from "@/context/ShopContext";
import { offerPush } from "@/lib/push";

export const WishAlert = ({ p, onChange }) => {
  const { cart } = useShop();
  const [busy, setBusy] = useState(false);
  if (p.login_required || !p.in_other_carts || p.stock > 0 || cart.some((i) => i.product_id === p.id)) return null;
  const toggle = async () => {
    setBusy(true);
    try {
      if (p.wish_alert) {
        await api.delete(`/wish-alerts/${p.id}`);
        toast.success("Avviso annullato");
      } else {
        await api.post(`/wish-alerts/${p.id}`);
        toast.success("Ti avvisiamo appena torna disponibile");
        setTimeout(offerPush, 600);
      }
      onChange();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <button onClick={toggle} disabled={busy} data-testid={`wish-alert-${p.wish_alert ? "cancel" : "subscribe"}-${p.id}`}
      className={`mt-2 flex w-full items-center justify-center gap-2 rounded-full px-4 py-2 text-xs font-bold transition-colors disabled:opacity-50 ${p.wish_alert ? "border-2 border-black/20 text-stone-700 hover:bg-black/5" : "bg-black text-white hover:bg-stone-800"}`}>
      <BellRing className="h-4 w-4" />{p.wish_alert ? "Annulla avviso email" : "Avvisami via email"}
    </button>
  );
};
